module.exports = __webpack_public_path__ + "img/cube-01.4ad61251.svg";